import { HttpResponse } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ViajesService } from 'src/app/_services/viajes.service';
import { ModalMsgComponent } from '../modal-msg/modal-msg.component';

@Component({
  selector: 'app-modal-confirm',
  templateUrl: './modal-confirm.component.html',
  styleUrls: ['./modal-confirm.component.css']
})
export class ModalConfirmComponent implements OnInit {
  @Input() id: string;

  constructor(
    public activeModal: NgbActiveModal,
    private router: Router,
    private modalService: NgbModal,
    private viajesService:ViajesService,
  ) { }

  ngOnInit(): void {    
  }
  aceptar(){
    this.viajesService.deletePaquete(this.id).subscribe(data => {
      if(data instanceof HttpResponse) { 
        this.modalService.dismissAll('Cross click');
        const modalRef = this.modalService.open(ModalMsgComponent, { 
          centered: true,  
          backdrop:'static',      
        });
        modalRef.componentInstance.label = 'Volver'; 
        if(data.body.msg === 'PACK_DELETE_SUCCESS')  {          
          modalRef.componentInstance.titulo = 'Viaje eliminado';
          modalRef.componentInstance.check = 1;           
        } else {
          modalRef.componentInstance.check = 0;    
          modalRef.componentInstance.titulo = 'Ha ocurrido un error';  
        } 
        this.redirectTo(this.router.url);
      }
       
    });
  }

  cancelar(){
    this.activeModal.dismiss('Cross click');
  }

  redirectTo(uri) {
    this.router.navigateByUrl('/', {skipLocationChange: true}).then(() =>
    this.router.navigate([uri]));
  }

}
